<template>

<div>
  <section v-if="!registered">
    <div class="add-device">
    <div class="container">
    <div class="row">
      <div class="col-md-7">
        <h2>Air Quality Data Request</h2>
        <span class="detail"><p> We are happy to learn of your interest in Drishti Kathmandu's air quality data. Please fill out the form below so we can help provide you the information necessary.</p></span>
        <form id="form" v-on:submit.prevent="registerData">
          <div class="form-group">
            <label for="email">Email address<span>*</span></label>
            <input type="text" class="form-control" v-model="email" 
            v-on:input="$v.email.$touch" v-bind:class="{error: $v.email.$error, valid: $v.email.$dirty && !$v.email.$invalid}">
          </div>
          <div class="form-group">
            <label for="name">Name<span>*</span></label>
            <input type="text" class="form-control"  v-model="name" v-on:input="$v.name.$touch" v-bind:class="{error: $v.name.$error, valid: $v.name.$dirty && !$v.name.$invalid}"> 
          </div>
          
          <div class="form-group">
            <label for="address">Current city or country of residence</label>
            <input type="text" class="form-control"   v-model="address" >
            
          </div>
          <div class="form-group">
           
            <label for="file">File format preference</label>
             <label>Data in Excel, if feasible other formats may be accommodated.</label>
            <input type="text" class="form-control"   v-model="file"  v-on:input="$v.file.$touch" v-bind:class="{error: $v.file.$error, valid: $v.file.$dirty && !$v.file.$invalid}"> 
          </div>
          <div class="form-group">
            <label for="profession">Proffession<span>*</span></label>
             <label>If student, please mention year & field of study</label>
            <input type="text" class="form-control"   v-model="proffession" >
            
          </div>
          <div class="form-group">
            <label for="affiliation">University or organization affiliation</label>
            <input type="text" class="form-control"   v-model="affiliation" >
          
          </div>
           <div class="form-group">
            <label for="request">Requesting data from (mm/dd/yy) to (mm/dd/yy)<span>*</span></label>
            
           <input type="date"  v-model="from" v-on:input="$v.from.$touch" v-bind:class="{error: $v.from.$error, valid: $v.from.$dirty && !$v.from.$invalid}">

           <input type="date"  v-model="to" v-on:input="$v.to.$touch" v-bind:class="{error: $v.to.$error, valid: $v.to.$dirty && !$v.to.$invalid}">
          </div>
           <div class="form-group">
            <label for="location">Requesting data from (location)<span>*</span></label>
            <input type="text" class="form-control"   v-model="location"  v-on:input="$v.location.$touch" v-bind:class="{error: $v.location.$error, valid: $v.location.$dirty && !$v.location.$invalid}"> 
          </div>
          <div class="form-group">
            <label for="usedby">The data will be used by:</label>
            <input type="text" class="form-control" v-model="usedby" >
           
          </div>
          <div class="form-group">
            <label for="usedfor">Data will be used for:</label>
            <input type="text" class="form-control" v-model="usedfor" >
           
          </div>
         <div class="form-group">
            <label for="purpose">To help Drishti Kathmandu understand how the air quality data will be used, please briefly describe the purpose your data request.<span>*</span></label>
            <label>Please make sure to include (a) project goals (b) how data will be applied and (c) if you would be willing to share or co-produce material with Drishti Kathmandu.</label>
            <textarea rows="4"  cols="60"  v-model="purpose" v-on:input="$v.purpose.$touch" v-bind:class="{error: $v.purpose.$error, valid: $v.purpose.$dirty && !$v.purpose.$invalid}"></textarea>
            
            
          </div>
          <div class="form-group">
            <label for="contact">Preferred contact person & information<span>*</span></label>
            <label>To follow up on how Drishti Kathmandu’s data was made more useful by your efforts</label>  
           <input type="text" class="form-control" v-model="contact" v-on:input="$v.contact.$touch" v-bind:class="{error: $v.contact.$error, valid: $v.contact.$dirty && !$v.contact.$invalid}"> 
            
            
          </div>
          <button type="submit" class="btn btn-default device-btn" :disabled="$v.$invalid">submit</button>
          <!--  v-on:click="getQuote()"-->
      </form>
    </div>
    <div class="col-md-5"></div>
</div>
  <div class="form-group" style="margin-top:20px">
      <div class='alert alert-danger' v-if='errors.length > 0'>
          <strong>Whoops!</strong> {{inputError}}<br><br>
          <ul>
              <li v-for='error in errors'>
                  {{ error }}
              </li>
          </ul>
      </div>
  </div>
  </div>
  </div><!-- end add device -->
  </section>

  <section class="bg-color" v-if="registered">
      <div class="container">
        <div class="error-content">
         <h2>Success</h2>
         <p>Thank you for taking the time to reach out to Drishti Kathmandu! We intend to respond to your data request and email you the relevant file as soon as possible.</p>
        </div><!-- end error-content -->
        </div>
  </section>
</div>

</template>
<script>
import {HTTP} from '../http-common.js'
import Vue from 'vue'
import Validations from 'vuelidate'
import { required, minLength, between,email,alphaNum,numeric } from 'vuelidate/lib/validators'
// import Multiselect from 'vue-multiselect'
  // register globally
Vue.use(Validations)

export default {
  name: 'request',
  data () {
    return {
      name: '',
      email : '',
      address : '',
      file : '',
      address : '',
      proffession : '',
      affiliation : '',
     
      from:'',
      to:'',
      location: '',
      usedby: '',
      usedfor: '',
      purpose:'',
      contact:'',
      errors: [],
      inputError : '',
      registered : false
    }
  },
  validations: {
    name: {
      required,
      minLength: minLength(4)
    },
    email: {
      required,
      email
    },
    
    file: {
      minLength: minLength(2)
    },
      proffession: {
      required
      
    },
   
    from: {
      required
      
    },
    to: {
      required
      
    },
    location: {
      required
    },
    
    purpose: {
      required
    },
    contact: {
      required
    }
  },
  methods: {
     registerData: function () {
           var vm = this
               
     if (!vm.$v.$invalid) {         
        vm.errors = []
        var options = {
          name: vm.name,
          email: vm.email,
          address: vm.address,
          file: vm.file,
          affiliation: vm.affiliation,
          proffession: vm.proffession,
         
          from:vm.from,
          to:vm.to,
          location:vm.location,
          usedby:vm.usedby,
          usedfor:vm.usedfor,
          purpose:vm.purpose,
          contact:vm.contact,
        }

       
        //console.log(options)
        HTTP.post('request/data', options)
        .then(function (response) {
          console.log('hello');
          if(response.status==200){
            vm.registered = true
          }
        })
        .catch(e => {
          if (e.response) {
                 // console.log(e.response);return false;
            vm.error = true
            if (typeof e.response.data.errors === 'object') {
                vm.inputError = "There was problem with your input"
                $.each(e.response.data.errors, function(key, value) {
                    vm.errors.push(value)
                });
            } else {
                vm.inputError = ''
                vm.errors.push('Something went wrong. Please try again.');
            }

          } else {
            console.log(e.response);return false;
            vm.errors.push('Something went wrong. Please try again.');
          }
        })
    }



   
  }
}
}
</script>

<style>
/*input {
  border: 1px solid silver;
  border-radius: 4px;
  background: white;
  padding: 5px 10px;
}*/
.device-type label {
    display: inline-block;
}
.error {
  border: 1px solid red !important;
  background: #FDD;
}
h2{
  color: green;
  
}
.detail p{
  color:black;
  margin-top: 20px ;
  margin-bottom: 10px ;

}


</style>



// WEBPACK FOOTER //
// DataRequest.vue?7fffb316